import DadosGerais from "components/Features/Empresa/FormEmpresa/DadosGerais";
import DadosDeEndereco from "components/FormEndereco";
import {
  EmpresaDetalhe,
  TipoCadastroEmpresa,
} from "core/resources/types/empresa";

interface SourceStep {
  title: string;
  component: React.FC<any>;
  extraProps?: Record<string, any>;
}

export default function getSteps(props: {
  requiredEndereco: boolean;
  tipoCadastroEmpresa?: TipoCadastroEmpresa;
  isUnidadePessoaEdit?: boolean;
  form?: EmpresaDetalhe;
}): SourceStep[] {
  const {
    tipoCadastroEmpresa,
    isUnidadePessoaEdit,
    requiredEndereco = true,
    form,
  } = props;

  const steps: SourceStep[] = [
    {
      title: "Dados Cadastrais",
      component: ({
        control,
        setField,
        watch,
        isEdit,
      }: {
        control: any;
        setField: any;
        watch: any;
        isEdit?: boolean;
      }) => (
        <DadosGerais
          isEdit={isEdit}
          control={control}
          setField={setField}
          tipoCadastroEmpresa={tipoCadastroEmpresa}
          isUnidadePessoaEdit={isUnidadePessoaEdit}
          form={form}
          watch={watch}
        />
      ),
    },
    {
      title: "Informações Adicionais",
      component: ({
        control,
        setField,
        watch,
        isEdit,
      }: {
        control: any;
        setField: any;
        watch: any;
        isEdit?: boolean;
      }) => (
        <DadosDeEndereco
          control={control}
          setField={setField}
          watch={watch}
          required={requiredEndereco}
          shouldUnregister={!tipoCadastroEmpresa && !isUnidadePessoaEdit}
        />
      ),
    },
  ];

  return steps;
}
